import request from './service'
// let BASEUrl = "https://formflow.paas.newcapec.cn/formflow"
// 获取我的历史分享
export function getMyHisList (data) {
  return request({
    url: `/v1/data/share/myHis/getMyHisList`,
    method: 'get',
    params: data,
    headerType: 'forward'
  })
}
// 撤回我的历史分享(个人)
export function backView (data) {
  return request({
    url: `/v1/data/share/myHis/backView`,
    method: 'put',
    data: data,
    headerType: 'forward'
  })
}
// 撤回我的历史分享(整个)
export function backShare (data) {
  return request({
    url: `/v1/data/share/myHis/backShare/${data}`,
    method: 'put',
    headerType: 'forward'
  })
}
// 历史分享详情页
export function getCondition (data) {
  return request({
    url: `/v1/data/share/query/detail/condition?pageNum=${data.pageNum}&pageSize=${data.pageSize}&shareId=${data.shareId}&keyWord=${data.keyWord}`,
    method: 'post',
    data: data.condition,
    headerType: 'forward'
  })
}
// 通过shareId获取主表之前勾选的列（高级查询里的查询字段和排序字段）
export function getFields (data) {
  return request({
    url: `/v1/data/share/query/detail/fields/${data}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 通过yyid获取主表之前勾选的列（高级查询里的查询字段和排序字段）
export function getFieldsByYYID (data) {
  return request({
    url: `/v1/data/share/query/fields`,
    method: 'get',
    params: {
      yyid: data
    },
    headerType: 'forward'
  })
}
// 按批次查询历史分享
export function getHisbyBatch (data) {
  return request({
    url: `/v1/data/share/myHis/getMyHisList/byBatch`,
    method: 'get',
    params: data,
    headerType: 'forward'
  })
}
// 查看分享对象
export function viewUser (data) {
  return request({
    url: `/v1/data/share/myHis/viewUser/${data.shareId}`,
    method: 'get',
    params: data.pages,
    headerType: 'forward'
  })
}
// 查看分享给我的数据
export function shareForme (data) {
  return request({
    url: `/v1/data/share/myHis/getShareForMe`,
    method: 'get',
    params: data,
    headerType: 'forward'
  })
}
// 记录分享给我的数据的查看状态
export function updateViewState (data) {
  return request({
    url: `/v1/data/share/myHis/updateViewState/${data}`,
    method: 'put',
    headerType: 'forward'
  })
}
// 获取分享字段
export function getShareInfo (data) {
  return request({
    url: `/v1/data/share/getShareInfo/${data}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 根据勾选字段和添加的筛选条件高级查询
export function getQueryInfo (data) {
  return request({
    url: `/v1/data/share/query/condition?pageNum=${data.pageNum}&pageSize=${data.pageSize}&yyid=${data.yyid}`,
    method: 'post',
    data: data.condition,
    headerType: 'forward'
  })
}
// 验证条件关系是否正确
export function checkQuery (data) {
  return request({
    url: `/v1/data/share/checkQuery`,
    method: 'post',
    data: data,
    headerType: 'forward'
  })
}
// 获取历史分享条件
export function getHisShare (data) {
  return request({
    url: `/v1/data/share/getHisShare/${data.yyid}`,
    method: 'get',
    params: {
      department: data.department
    },
    headerType: 'forward'
  })
}
// 查看历史分享条件详情（可编辑的）
export function getShareDetail (data) {
  return request({
    url: `/v1/data/share/getShareDetail/${data}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 保存分享表单
export function saveShare (data) {
  let tempUrl = ''
  if (data.isTemp) {
    // 暂存
    tempUrl = `/v1/data/share/shareSave?isTemp=${data.yyid}`
  } else {
    // 分享
    tempUrl = `/v1/data/share/shareSave`
  }
  return request({
    url: tempUrl,
    method: 'post',
    data: data.shareTask,
    headerType: 'forward'
  })
}
// 查询要导入已保存的分享表单
export function getTempSave (data) {
  return request({
    url: `/v1/data/share/getTempSave/${data}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 获取部门树
export function getDepartTree () {
  return request({
    url: `/v1/data/share/org/tree`,
    method: 'get',
    headerType: 'forward'
  })
}
// 根据部门获取人员信息
export function getDepartUser (data) {
  return request({
    url: `/v1/data/share/user/org?id=${data.id}&isLoadingAll=${data.isLoadingAll}&keyword=${data.keyword}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 分页查询用户信息
export function getUsers (data) {
  return request({
    url: `/v1/data/share/user/page?keyword=${data.keyword}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 获取普通用户组
export function getCommonGroup (data) {
  return request({
    url: `/v1/data/share/group/list?isLoadingUser=${data.isLoadingUser}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 获取岗位用户组
export function getOrgGroup (data) {
  return request({
    url: `/v1/data/share/group/organizations/list?isLoadingUser=${data.isLoadingUser}`,
    method: 'get',
    headerType: 'forward'
  })
}

// 根据用户组查人员
export function getuserByGroup (data) {
  return request({
    url: `/v1/data/share/group/userPage/byGroupId?id=${data.id}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: 'get',
    headerType: 'forward'
  })
}
// 根据用户组查人员
export function isShow () {
  return request({
    url: `/v1/data/share/myHis/isShow`,
    method: 'get',
    headerType: 'forward'
  })
}
